/**
 * Search Context Handler
 * Automatically adds ?view=kids to search queries from kids pages
 * This ensures the correct header (kids vs adult) displays on search results
 */

class SearchContextHandler {
  constructor() {
    this.init();
  }

  init() {
    // Detect if we're on a kids page
    const isKidsPage = this.detectKidsContext();
    
    if (isKidsPage) {
      console.log('🎨 Kids context detected - will add ?view=kids to search');
      this.interceptSearchForms('kids');
    } else {
      console.log('🎨 Adult context detected - will add vendor to search');
      this.interceptSearchForms('adult');
    }
  }

  /**
   * Detect if current page is kids context
   * Check URL path or header structure
   */
  detectKidsContext() {
    // On search results page, ONLY use the URL parameter to determine context
    // This prevents the "sticky kids" loop
    if (window.location.pathname.includes('/search')) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('view') === 'kids';
    }

    // Method 1: Check URL path
    const path = window.location.pathname;
    if (path.includes('/pages/kids') || 
        path.includes('/collections/kids') || 
        path.includes('/collections/boys') || 
        path.includes('/collections/girls')) {
      return true;
    }

    // Method 2: Check if kids header is loaded (kids logo in first tab position)
    const headerTabs = document.querySelector('.header-tabs, .header-tabs-mobile');
    if (headerTabs) {
      const firstTab = headerTabs.querySelector('li:first-child a');
      if (firstTab) {
        const hasKidsLogo = firstTab.querySelector('[data-icon*="kids-logo"]');
        return !!hasKidsLogo;
      }
    }

    // Method 3: Check if kids header wrapper is visible
    const kidsWrapper = document.getElementById('header-kids-wrapper');
    if (kidsWrapper && getComputedStyle(kidsWrapper).display !== 'none') {
      return true;
    }

    return false;
  }

  /**
   * Intercept all search forms and add view/vendor parameters
   * @param {string} context - 'kids' or 'adult'
   */
  interceptSearchForms(context) {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.attachFormHandlers(context));
    } else {
      this.attachFormHandlers(context);
    }
  }

  attachFormHandlers(context) {
    const searchForms = document.querySelectorAll('form[action*="/search"]');
    
    searchForms.forEach(form => {
      form.addEventListener('submit', (e) => {
        if (context === 'kids') {
          // Add hidden input for ?view=kids
          const existingViewInput = form.querySelector('input[name="view"]');
          
          if (!existingViewInput) {
            const viewInput = document.createElement('input');
            viewInput.type = 'hidden';
            viewInput.name = 'view';
            viewInput.value = 'kids';
            form.appendChild(viewInput);
            
            console.log('✅ Added ?view=kids to search form');
          }

          // Add hidden input for vendor=ABERCROMBIE KIDS
          const existingVendorInput = form.querySelector('input[name="vendor"]');
          
          if (!existingVendorInput) {
            const vendorInput = document.createElement('input');
            vendorInput.type = 'hidden';
            vendorInput.name = 'vendor';
            vendorInput.value = 'ABERCROMBIE KIDS';
            form.appendChild(vendorInput);
            
            console.log('✅ Added vendor=ABERCROMBIE KIDS to search form');
          }
        } else {
          // Adult context - add vendor parameter only
          const existingVendorInput = form.querySelector('input[name="vendor"]');
          
          if (!existingVendorInput) {
            const vendorInput = document.createElement('input');
            vendorInput.type = 'hidden';
            vendorInput.name = 'vendor';
            vendorInput.value = 'ABERCROMBIE & FITCH';
            form.appendChild(vendorInput);
            
            console.log('✅ Added vendor=ABERCROMBIE & FITCH to search form');
          }
        }
      });
    });

    console.log(`🔗 Attached handlers to ${searchForms.length} search form(s) for ${context} context`);
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new SearchContextHandler());
} else {
  new SearchContextHandler();
}
